// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtQuantity } from '../../../../../lib/trix-web-data-commons';

//
// Cell renderer
//
import {
    createItemSubItemCellRenderer,
} from '../../../../../lib/trix-web-components-table';

const createShipmentOrderLineQuantitiesTableColumn = (cfg: any): any => {
    return {
        align: 'right',
        flex: false,
        width: 120,

        renderCell: createItemSubItemCellRenderer({
            ...cfg.cellRendererFactoryProps,

            align: 'right',

            getItem: (props: any) => {
                return fmtQuantity((props.row && props.row.quantity) ? 
                        props.row.quantity : undefined);
            },

            getSubItem: (props: any) => {
                const reservedQuantity = (props.row && props.row.reservedQuantity) ? props.row.reservedQuantity : {
                    amount: 0.0, 
                    unit: '-'
                };
                const soldQuantity = (props.row && props.row.soldQuantity) ? props.row.soldQuantity : {
                    amount: 0.0, 
                    unit: '-'
                };
                const cancelledQuantity = (props.row && props.row.cancelledQuantity) ? props.row.cancelledQuantity : {
                    amount: 0.0, 
                    unit: '-'
                };
                return `${fmtQuantity(reservedQuantity)} / ${fmtQuantity(soldQuantity)} (${fmtQuantity(cancelledQuantity)})`;
            }
        })
    }
}
export default createShipmentOrderLineQuantitiesTableColumn;